import { Box } from "@mui/material";
import styled from "styled-components";

export const Content = styled(Box)`
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  position: absolute;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;

  width: 600px;
  align-items: left;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 20px;
`;

export const ViewData = styled(Box)`
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;

export const ActionsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;

  > button:first-child {
    margin-right: 10px;
  }
`;
